import { DatePipe } from "@angular/common";
import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { CommonService } from "src/app/services/common.service";
import { GlobalService } from "src/app/services/global.service";
const Excel = require("exceljs");
import Swal from "sweetalert2";
import * as SecureLS from "secure-ls";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-raspberry-device",
  templateUrl: "./raspberry-device.component.html",
  styleUrls: ["./raspberry-device.component.css"],
})
export class RaspberryDeviceComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  active = 1;
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");
  view_File_name: any;
  alphaPattern = "[a-zA-Z .,]*";
  selectedFiles: any;
  RaspberryForm: FormGroup;
  bulkcreate: any;
  showLoadMore = false;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  manualUpdate = true;
  swal: any;
  total_count = 0;
  rascreate: any;
  raspberryList: any[];
  getraspberry: any;
  editraspberry: any;
  is_active = false;
  deleteraspberry: any;
  editstatus = false;
  rasupdate: any;
  rasstatusupdate: any;
  editid: any;
  isactiveswitch: any;
  editbut: boolean;
  rasname: any;
  rastype: any;
  rasip: any;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  total: number;
  p: number;
  pagedItems: any[];
  writehide = false;
  writeaccess = this.ls.get("write_access");
  searchForm: FormGroup;
  chiparray: any = [];
  filtervalues: boolean;
  bulk_form: FormGroup;
  entryFields: boolean = false;
  createNew: boolean = true;
  backendValidationErrors: null;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private fb: FormBuilder,
    public globalService: GlobalService,
    public fileupload: CommonService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {}

  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      ras_name: [""],
      ras_ip: [""],
    });
    this.RaspberryForm = this.fb.group({
      id: [""],
      raspberry_ip: ["", [Validators.required]],
      name: ["", [Validators.required]],
      is_active: [""],
    });

    this.bulk_form = this.fb.group({
      bulk_file: [""],
    });

    this.RaspberryForm.valueChanges.subscribe((data)=>{
      this.backendValidationErrors = null;
    });

    this.page = 1;
    if (this.ls.get("write_access") == 0) {
      this.writehide = true;
    }
    await this.getRaspberry();
    await this.getPage(this.page, true);
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.RaspberryForm.reset();
    this.submitted = false;
  }

  onActiveTab(active) {
    if (active !== 1) {
      this.bulk_form.controls["bulk_file"].patchValue("");
    }
  }

  cancelFields(isEditbut?) {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.RaspberryForm.reset();
    this.createNew = true;
    if (isEditbut) {
      this.editbut = false;
    }
  }
  async getPage(page: number,disableCall:boolean) {
    this.page = page;
    if(!disableCall){
   await this.getRaspberry();
    }
    const res = await this.serverCall(this.raspberryList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms() {
    return this.RaspberryForm.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }

  // Modal
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  switch(e) {
    this.isactiveswitch = e;
  }
  async createRaspberry(form: FormGroup) {
    this.submitted = true;

    if (this.RaspberryForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      raspberry_ip: form.value.raspberry_ip,

      name: form.value.name,
      is_active: this.isactiveswitch
        ? this.isactiveswitch == true
          ? "1"
          : "0"
        : "0",
    };
    this.rascreate = await this.globalService.create(
      "raspberry/create",
      inputData
    );

    if (this.rascreate["status"] === 200) {
      Swal.fire("Success!", this.rascreate["message"], "success");
      this.pageshow = true;
      this.getRaspberry();
      this.reset();
      this.bulk_form.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, 'modal-open')
    } else if (this.rascreate["status"] === 422) {
      this.backendValidationErrors = this.rascreate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }
  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.view_File_name = this.selectedFiles.item(0).name;
  }

  async BulkUpload(form: FormGroup) {
    if (
      form.value.bulk_file === null ||
      form.value.bulk_file === undefined ||
      form.value.bulk_file === ""
    ) {
      Swal.fire("", "Please upload the file", "error");
    }
    let dataExport = [];
    let file;
    let files;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(this.selectedFiles[0]);
    if (this.selectedFiles != null) {
      const file = this.selectedFiles.item(0);
      if (
        file.type !== "application/vnd.ms-excel" &&
        file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type !== "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        this.spinner.hide();
        Swal.fire("Error!", "Only Excel files are allowed", "error");
        return;
      }
      if (file.size > 2097152) {
        Swal.fire("Warning!", "File Size Must be under 2 MB", "warning");
        return false;
      }
      if (
        file.type == "application/vnd.ms-excel" ||
        file.type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type == "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        let formdata = new FormData();
        formdata.append("file", file);
        formdata.append("user_id", this.ls.get("createdBy"));
        formdata.append("vendor_id", this.ls.get("vendor_id"));
        formdata.append("upload_role_id", "4");
        formdata.append("role_id", String(this.storageService.getRole()));
        formdata.append("requester_type", "web");

        this.spinner.show();
        reader.onload = async (e: any) => {
          /* create workbook */ const binarystr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });

          /* selected the first sheet */ const wsname: string =
            wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
          /* save data */ //const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1};

          const data = XLSX.utils.sheet_to_json(ws);

          if (data.length > 100) {
            this.spinner.hide();
            Swal.fire(
              "Warning!",
              "Records more than 100 not be allowed",
              "warning"
            );

            return;
          } else {
            this.bulkcreate = await this.globalService.update(
              "raspberry/upload/excel",
              formdata
            );
            if (this.bulkcreate["status"] === 200) {
              let bulk = this.bulkcreate["content"];
              const expectedHeaders = ["raspberry_ip", "name"];

              const missingDataRows = bulk.filter((row) => {
                return expectedHeaders.some((header) => !row[header]);
              });
              if (missingDataRows.length > 0) {
                Swal.fire(
                  "Warning!",
                  "Some rows are missing data for required headers. Please check the file.",
                  "warning"
                );
              } else {
                for (let i = 0; i < bulk.length; i++) {
                  dataExport.push({
                    Sno: i + 1,
                    raspberry_ip: bulk[i].raspberry_ip,
                    name: bulk[i].name,
                    message: bulk[i].message,
                  });
                }

                var a = await this.fileupload.exportExcel(
                  dataExport,
                  "Raspberry List"
                );
                Swal.fire("Success!", this.bulkcreate["message"], "success");
                this.getRaspberry();
                this.pageshow = true;
                this.bulk_form.reset();
              }
            }
          }
        };
      }
    }
    this.spinner.hide();
    this.cancelFields();
  }
  Filter(rasname, rastype, rasip) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.rasname != undefined && this.rasname != "") {
      this.chiparray.push("Raspberry Name:" + " " + this.rasname);
    }

    if (this.rasip != undefined && this.rasip != "") {
      this.chiparray.push("Raspberry IP:" + " " + this.rasip);
    }
    this.rasip = rasip;
    this.rasname = rasname;
    this.rastype = rastype;

    if (rasip == null || rasip == "") {
      this.pageshow = true;
      this.page = 1;
      this.getRaspberry();
    } else if (rasip != null) {
      let ras_check = new RegExp(
        "((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(.|$)){4}"
      );
      let validate_ip = ras_check.test(rasip);
      if (validate_ip === true) {
        this.rasip = rasip;
        this.pageshow = true;
        this.page = 1;
        this.getRaspberry();
      } else {
        this.filtervalues = false;
        Swal.fire("Warning!", "Please Provide the Valid IP", "warning");
        return false;
      }
    }
  }

  res() {
    this.filtervalues = false;
    this.rasname = null;
    this.rastype = null;
    this.rasip = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getRaspberry();
  }
  async getRaspberry() {
    this.spinner.show();
    if (this.page === 1) {
      this.raspberryList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      page_size: this.page_size,
      role_id: this.storageService.getRole(),
      name: this.rasname ? this.rasname : "",
      type: this.rastype ? this.rastype : "",
      raspberry_ip: this.rasip ? this.rasip : "",
    };

    this.getraspberry = await this.globalService.get("raspberry/list", filter);

    if (this.getraspberry["status"] === 200) {
      this.total_count = this.getraspberry["content"].count;
      if (this.getraspberry["content"]["rows"].length < this.page_size) {
        this.showLoadMore = true;
      }
      this.raspberryList = this.getraspberry["content"]["rows"];

      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    } else {
      this.htmlpageshow = false;
      this.showLoadMore = true;
      this.spinner.hide();
    }

    (error) => {
      this.raspberryList = [];
      this.spinner.hide();
      this.showLoadMore = true;
    };

    this.spinner.hide();
  }
  editRaspberry(id, raspberry_ip) {
    this.spinner.show();
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.editbut = true;
        this.openField();
        this.spinner.show();
        this.active = 2;
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          raspberry_ip: raspberry_ip,
        };
        this.editraspberry = await this.globalService.get(
          "raspberry/get",
          filter
        );
        let comp_details = this.editraspberry["content"];

        if (this.editraspberry["status"] === 200) {
          this.RaspberryForm.controls["id"].setValue(comp_details.id);
          this.RaspberryForm.controls["raspberry_ip"].setValue(
            comp_details.raspberry_ip
          );

          this.RaspberryForm.controls["name"].setValue(comp_details.name);

          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
        this.editbut = false;
      }
    });
    this.spinner.hide();
  }
  reset() {
    this.submitted = false;
    this.RaspberryForm.reset();
    this.editstatus = false;
    this.isactiveswitch = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getRaspberry();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getRaspberry();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getRaspberry();
  }
  RaspberryStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        this.manualUpdate = value;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };
        this.rasstatusupdate = await this.globalService.update(
          "raspberry/update/status",
          inputData
        );
        if (this.rasstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.rasstatusupdate["message"], "success");
          this.pageshow = true;
          this.getRaspberry();
        }
        if (this.rasstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getRaspberry();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getRaspberry();
      }
    });
    this.spinner.hide();
  }
  async updateRaspberry(form: FormGroup) {
    this.submitted = true;

    if (this.RaspberryForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      id: form.value.id,
      vendor_id: this.ls.get("vendor_id"),
      is_active: this.is_active ? this.is_active : this.editstatus,
      user_id: this.ls.get("createdBy"),
      raspberry_ip: form.value.raspberry_ip,

      name: form.value.name,
    };
    this.rasupdate = await this.globalService.update(
      "Raspberry/update",
      inputData
    );

    if (this.rasupdate["status"] === 200) {
      Swal.fire("Success!", this.rasupdate["message"], "success");
      this.editbut = false;
      this.pageshow = true;
      this.getRaspberry();
      this.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, 'modal-open')
    } else if (this.rasupdate["status"] === 422) {
      this.backendValidationErrors = this.rasupdate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }
  async downloadSampleTemplate() {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.getCell("A1").value = "Sno";
    worksheet.getCell("B1").value = "Raspberry_IP";
    worksheet.getCell("C1").value = "Raspberry_Name";

    worksheet.getCell("A2").value = "1";
    worksheet.getCell("B2").value = "172.16.6.3";
    worksheet.getCell("C2").value = "RAS_123";

    for (let i = 2; i < 2500; i++) {
      worksheet.getCell(`D${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$J$1:$J$1048576"],
      };
    }

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 20;

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Raspberry Sample List" + ".xlsx");
    });
  }

  async deleteRaspberry(id, raspberry_ip) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          raspberry_ip: raspberry_ip,
        };
        this.deleteraspberry = await this.globalService.delete(
          "raspberry/delete",
          filter
        );
        if (this.deleteraspberry["status"] === 200) {
          this.raspberryList = [];
          Swal.fire("Success!", this.deleteraspberry["message"], "success");
          this.pageshow = true;
          this.getRaspberry();
        }
      }
    });
    this.spinner.hide();
  }

  resetbulk() {
    this.bulk_form.reset();
  }

  formAddReset() {
    this.RaspberryForm.reset();
    this.editbut = false;
    this.bulk_form.reset();
  }
  formUpdateReset() {
    this.RaspberryForm.controls["id"].setValue(
      this.editraspberry["content"].id
    );
    this.RaspberryForm.controls["raspberry_ip"].setValue(
      this.editraspberry["content"].raspberry_ip
    );

    this.RaspberryForm.controls["name"].setValue(
      this.editraspberry["content"].name
    );
    this.RaspberryForm.reset();
    this.RaspberryForm.get("id").setValue(this.editraspberry["content"].id);
  }

  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getRaspberry();
  }
}
